import { _CATCH_PREFIX } from "@/utils/app.js";

// 订单详情 一些信息
export const BIZINFO = `${_CATCH_PREFIX}_bizInfo`;

// 登录过期校验信息
export const LOGIN_EXPIRED = `${_CATCH_PREFIX}_login_expired`;
